import { AccountingSingletonAccountsService_singletonAccountsServiceGetSingletons } from '@festina/life-general-types/life/hooks/AccountingSingletonAccountsService_singletonAccountsServiceGetSingletons'

export const useFetchAllAccountSingletons =
  AccountingSingletonAccountsService_singletonAccountsServiceGetSingletons.useSuspenseQuery
